import { Component, Input, OnInit, OnChanges, Output, EventEmitter, SimpleChanges, HostBinding } from '@angular/core';
import { QueryCondition } from '../../entity/querycondition';
import { ComboLookUpControl } from '../../entity/controltype/combolookup/combolookupcontrol';
import { ComboLookUpValue } from '../../entity/conditionvalue/combolookupvalue';
import { SolutionService } from '../../service/solution.service';
import { ControlType } from '../../entity/controltype';

@Component({
    selector: 'app-filter-combolookup',
    templateUrl: './combolookup.component.html',
})

export class ComboLookUpComponent implements OnInit,OnChanges{
   

    @Input() autoLabel: boolean;
    @Input() disabled: boolean;
    /**
     * QueryCondition类型
     */
    @Input() item:any;

    /**
     * 某个字段发生值变化事件时，需要同步清空的字段，可能不是当前字段
     */
    @Input() changeFields: Array<string> = [];

    @Output() searchHandle = new EventEmitter();

    uri: string;
    idField: any;
    valueField: any;
    textField: string;
    textValue: any;
    mapFields: any;
    displayType: any;
    multiSelect: boolean;
    preEventCmd: any;
    postEventCmd: any;
    enableFullTree: boolean;
    testId: string;
    placeholder: string;
    autoWidth: boolean;
    panelWidth: number;
    panelHeight: number;
    selectedValues = "";
    loadTreeDataType: string;
    context: any;
/** 判断是否是在扩展区域展示 */
    extend = false;
    /** 判断是否显示label */
    showlabel = true;
    editable = false;
    @HostBinding('class.filter-item-wrap')
        get isExtend(): boolean {
            return !this.extend && this.autoLabel;
        }
        @HostBinding('class.filter-item-hiddenlabel')
        get hidenLabel(): boolean {
            return !this.showlabel;
        }
    constructor(private solutionService: SolutionService){ }

    ngOnInit(): void {
        
        this.getComboLookUpBindingInfo();
        this.testId = this.solutionService.getGuid();
        this.placeholder = (this.item.placeHolder) ? (this.item.placeHolder) : (this.item.control.placeholder);
        this.autoWidth = false;
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.getComboLookUpBindingInfo();
        if(changes['changeFields'] && changes['changeFields'].currentValue && !changes['changeFields'].firstChange) {
            const isChange = changes['changeFields'].currentValue.some(field => field == this.item.fieldCode);
            if(isChange){
                this.textValue = (this.item.value as ComboLookUpValue).textValue;
            }
        }
    }

    valueChangeHandler(data: any){
        const helpValue = (this.item.value as ComboLookUpValue);
        helpValue.value = data.selections;
        helpValue.valueField = this.valueField;
        helpValue.textValue = helpValue.getTextValue(this.textField);
        this.textValue = helpValue.textValue;
        this.searchHandle.emit();
    }
    /**
     * 解决jit生成代码后下拉帮助控件的displayType属性与组件api不一致的问题
     * @param data 下拉帮助控件JSON描述中的displayType配置信息
     */
    private displayTypeTransform(data: any) {
        if (data === 'List') {
        return 'LOOKUPLIST';
        }
        return 'LOOKUPTREELIST';
    }
    getComboLookUpBindingInfo(){
         if (this.item && this.item.control && this.item.control.getControlType() == ControlType.ComboLookUp) {
        const comboLookUpControl = (this.item.control as ComboLookUpControl);
        this.uri = comboLookUpControl.uri;
        this.idField = comboLookUpControl.idField;
        this.valueField = comboLookUpControl.valueField;
        this.textField = comboLookUpControl.textField;
        this.mapFields = comboLookUpControl.mapFields;
        this.displayType = this.displayTypeTransform(comboLookUpControl.displayType);
        this.preEventCmd = comboLookUpControl.preEventCmd;
        this.postEventCmd = comboLookUpControl.postEventCmd;
        this.enableFullTree = comboLookUpControl.enableFullTree;
        this.multiSelect = comboLookUpControl.singleSelect === true ? false : true;
        this.panelWidth = comboLookUpControl.panelWidth ? comboLookUpControl.panelWidth : 300;
        this.panelHeight = comboLookUpControl.panelHeight ? comboLookUpControl.panelHeight : 300;
        this.loadTreeDataType = comboLookUpControl.loadTreeDataType;
        this.context = comboLookUpControl.context;
        const comboLookUpValue = (this.item.value as ComboLookUpValue);
        if(comboLookUpValue.textValue == 'help-text-value-null'){//旧数据兼容
            this.textValue = comboLookUpValue.getTextValue(this.textField);
        }else{
            this.textValue = comboLookUpValue.textValue;
        }

        if (comboLookUpValue && comboLookUpValue.value) {
            this.selectedValues = (comboLookUpValue.value || []).map(n => n[this.idField]).join(',');
        }
        this.editable = comboLookUpControl.editable !== undefined ? comboLookUpControl.editable : false;
    }
    }

    clearData(data: any){
        (this.item.value as ComboLookUpValue).clearValue();
        this.searchHandle.emit();
    }

    getConditionItemTitle(field:QueryCondition){
        return this.solutionService.getConditionItemTitle(field);
    }
}